/**
 * 빈 표 셀(<td></td> / <th></th> 및 공백·줄바꿈만 든 셀)에 빈 문단을 채운다.
 *
 * Tiptap tableCell/tableHeader의 content는 "block+"이라 자식 블록이 최소 1개 있어야 한다.
 * 빈 셀을 그대로 두면 Y.Doc 재구성(재로드/원격 동기화) 시
 * "Invalid content for node tableCell"로 문서 전체 렌더가 깨진다(붙여넣은 표가 사라짐).
 * 내용이 있는 셀은 Tiptap이 문단으로 자동 래핑하므로 빈 셀만 보정하면 된다.
 *
 * Excel/스프레드시트는 빈 칸을 `<td></td>`뿐 아니라 `<td> </td>`/`<td>\n</td>`처럼
 * 공백·줄바꿈을 넣어 내보낸다. ProseMirror가 파싱 시 그 공백을 제거하면 결국 빈 셀이 되어
 * 같은 크래시가 난다. 따라서 태그 사이가 공백류뿐인 셀(`>\s*<`)도 빈 셀로 보고 보정한다.
 * (`&nbsp;`/`<br>`은 유효한 셀 내용이므로 \s에 포함되지 않아 그대로 둔다.)
 *
 * 입력은 신뢰 가능한 변환기 출력이어야 한다:
 * - markdownToHtml: html:false라 td/th는 markdown-it 표 렌더러에서만 나온다.
 * - 붙여넣기 HTML: ProseMirror가 DOM으로 파싱하기 직전 단계라 정규화된 마크업이다.
 */
export const fillEmptyTableCells = (html: string): string =>
  html.replace(/<(td|th)([^>]*)>\s*<\/\1>/gi, "<$1$2><p></p></$1>");
